/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import 'core-js';
import ReactDOM from 'react-dom';
import 'styles/index.css';
import 'utility/polyfills';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));